import SkillsItem from "./SkillItem";

export default SkillsItem;
